<template>
    <div class="login-panel info-panel" v-if="beforeDate('2026-07-28')">
        <div class="info-text">
            <h4>
                <md-icon class="text-warning">info</md-icon>
            </h4>
            <b class="md-color-orange">Customer Notice</b>
            <p>We will be applying a series of security updates across our infrastructure, during which time the system will be taken down.</p>
            <p>The brief outage will occur on Monday <strong class="text-warning">27/07/2026</strong> between <strong class="text-warning">09:30 (BST)</strong> and <strong class="text-warning">10:00 (BST)</strong>.</p>
            <p><strong class="text-warning">Please note:</strong> this update will forcibly log all users out of the system. We strongly recommend that users save or complete any forms or tasks prior to 09:30 as not doing so has a high chance of resulting in data loss once users are logged out.</p>
            <p>Best wishes,<br />Navitas Safety Team</p>
        </div>
    </div>
</template>

<script>

    export default {
        name: "LoginNotice",
        methods: {
            beforeDate: function (to_date) {
                return (new Date()) < (new Date(to_date))
            },
            betweenDates: function (from_date, to_date) {
                return ((new Date()) >= (new Date(from_date))) && (new Date()) <= ((new Date(to_date)));
            },
        }
    }
</script>